// assets
// utils
import PropTypes from 'prop-types'
import tempImage from 'assets/images/icon-class.png'
import Image from 'components/atoms/Image/image'
// components
import Card from 'components/atoms/card/card'
import './program-card-internal.scss'
import RequiredSvgIcon from '../../atoms/icons/requiredSvg/requiredSvg'
import CompleteIconSvg from '../../atoms/icons/complete/complete'

const ProgramCardInternal = ({ required, complete, activityName, onClick, image }) => {
	return (
		<section className='m-program-card-internal'>
			<Card classes='m-program-card-internal__card morphism' onClick={onClick}>
				<section className='m-program-card-internal__header'>
					<Image
						src={image || tempImage}
						width='48'
						height='48'
						classes='m-program-card-internal__header__img'
					/>
					<div>
						<h4>{activityName}</h4>
					</div>
				</section>
				<section className='m-program-card-internal__icons-container'>
					{required && <RequiredSvgIcon />}
					{complete && <CompleteIconSvg />}
				</section>
			</Card>
		</section>
	)
}

ProgramCardInternal.defaultProps = {
	complementShadowElements: true
}

ProgramCardInternal.propTypes = {
	complementShadowElements: PropTypes.bool
}

export default ProgramCardInternal
